import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Link from "@mui/material/Link";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import ForumIcon from "@mui/icons-material/Forum";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import GroupIcon from "@mui/icons-material/Group";
import { getPlayersLabel } from "./getPlayersLabel";

const ServerHero = ({
    server,
    isMobile,
    isAuth,
    canAccessChat,
    showRating,
    showShop,
    onCopy,
    onOpenPlayers,
    onToggleRating,
    onToggleShop,
    onChatClick,
}) => (
    <Box
        sx={{
            display: "flex",
            flexDirection: isMobile ? "column" : "row",
            alignItems: isMobile ? "center" : "flex-start",
            textAlign: "left",
        }}
    >
        <Box
            component="img"
            src={server.img}
            alt={`${server.name} logo`}
            sx={{
                width: isMobile ? "100%" : 200,
                height: isMobile ? "auto" : 200,
                objectFit: isMobile ? "contain" : "cover",
                borderRadius: 2,
                marginBottom: isMobile ? 2 : 0,
                marginRight: isMobile ? 0 : 3,
                alignSelf: "center",
            }}
        />
        <Box sx={{ flexGrow: 1 }}>
            <Typography variant="h6" component="h2" gutterBottom>
                {server.name}
            </Typography>
            <Typography
                variant="subtitle2"
                color="text.secondary"
                sx={{ mt: 1, color: server.status === 3 ? "#89b6a1" : "#b98b97" }}
            >
                {server.status === 3 ? "Онлайн" : "Оффлайн"}: {getPlayersLabel(server.online)}
            </Typography>

            <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mt: 2 }}>
                <Button
                    variant="contained"
                    color="primary"
                    component={Link}
                    href={`steam://run/252490//+connect ${server.ip}:${server.port}`}
                    target="_blank"
                    title="Подключиться к серверу"
                >
                    Играть
                </Button>

                <Button
                    variant="outlined"
                    color="inherit"
                    onClick={onCopy}
                    startIcon={<ContentCopyIcon />}
                    title="Скопировать IP и порт"
                >
                    {isMobile ? "Копировать" : `${server.ip}:${server.port}`}
                </Button>

                {server.online_players && server.online_players.length > 0 && (
                    <Button
                        variant="outlined"
                        color="inherit"
                        onClick={onOpenPlayers}
                        startIcon={<GroupIcon />}
                        title="Показать игроков онлайн"
                    >
                        Игроки ({server.online_players.length})
                    </Button>
                )}

                {server.xdStats && Object.keys(server.xdStats).length > 0 && (
                    <Button
                        variant={showRating ? "contained" : "outlined"}
                        color="inherit"
                        onClick={onToggleRating}
                        startIcon={<EmojiEventsIcon />}
                        title="Показать статистику"
                    >
                        Статистика
                    </Button>
                )}

                {server.shop_items && server.shop_items.length > 0 && (
                    <Button
                        variant={showShop ? "contained" : "outlined"}
                        color="inherit"
                        onClick={onToggleShop}
                        startIcon={<ShoppingCartIcon />}
                        title="Показать магазин сервера"
                    >
                        Магазин
                    </Button>
                )}

                {isAuth && (
                    <Button
                        variant="outlined"
                        onClick={onChatClick}
                        startIcon={<ForumIcon />}
                        color={canAccessChat ? "primary" : "inherit"}
                        title={canAccessChat ? "Открыть чат" : "Свяжите аккаунт для доступа к чату"}
                    >
                        Чат
                    </Button>
                )}
            </Box>

            <Typography variant="subtitle2" color="text.secondary" sx={{ mt: 2 }}>
                Добавлен: {server.created}
            </Typography>
        </Box>
    </Box>
);

export default ServerHero;
